//Converts (first format) to (second format)

import { XY } from "./V2";
import type { BOX } from "./G2";

export const Conv = {
    flat_array: function (ia: any[], overwrite?: any[]) { //[x, y, x, y] -> [[x, y], [x, y]]
        if (!overwrite) overwrite = new Array(ia.length / 2);
        for (let i = 0; i < overwrite.length; i++) {
            overwrite[i] = [ia[i * 2], ia[i * 2 + 1]];
        }
        return overwrite;
    },
    array_flat: function (ia: any[], overwrite?: Float32Array): Float32Array { // [[x, y], [x, y]] -> [x, y, x, y]
        if (!overwrite) overwrite = new Float32Array(ia.length * 2);
        for (let i = 0; i < ia.length; i++) {
            overwrite[i * 2 + 0] = ia[i][0];
            overwrite[i * 2 + 1] = ia[i][1];
        }
        return overwrite;
    },
    xy_array: function (ia: XY[], overwrite?: any[]) { //[{x, y}, {x, y}] -> [[x, y], [x, y]]
        if (!overwrite) overwrite = new Array(ia.length);
        for (let i = 0; i < overwrite.length; i++) {
            overwrite[i] = [ia[i].x, ia[i].y];
        }
        return overwrite;
    },
    xy_float32: function (ia: XY[], overwrite?: Float32Array) { //[{x, y}, {x, y}] -> [x, y, x, y, ...]
        if (!overwrite) overwrite = new Float32Array(ia.length * 2);
        for (let i = 0; i < ia.length; i++) {
            overwrite[i * 2] = ia[i].x;
            overwrite[i * 2 + 1] = ia[i].y;
        }
        return overwrite;
    },
    array_xy: function (ia: any[], overwrite?: any[]): XY[] { // [[x, y], [x, y]] -> [{x, y}, {x, y}]
        if (!overwrite) overwrite = new Array(ia.length);
        for (let i = 0; i < ia.length; i++) {
            overwrite[i] = { x: ia[i][0], y: ia[i][1] };
        }
        return overwrite;
    },
    position_xy: function (ia: any[], overwrite?: XY[]) { //removes .position
        if (!overwrite) overwrite = new Array(ia.length);
        for (let i = 0; i < ia.length; i++) {
            overwrite[i] = ia[i].position;
        }
        return overwrite;
    },
    pos_xy: function (ia: any[], overwrite?: XY[]) { //removes .pos
        if (!overwrite) overwrite = new Array(ia.length);
        for (let i = 0; i < ia.length; i++) {
            overwrite[i] = ia[i].pos;
        }
        return overwrite;
    },
    xy_position: function (ia: any[], overwrite?: any[]) { //adds .position
        if (!overwrite) overwrite = new Array(ia.length);
        for (let i = 0; i < ia.length; i++) {
            overwrite[i] = { position: { x: ia[i].x, y: ia[i].y } };
        }
        return overwrite;
    },
    xy_pos: function (ia: any[], overwrite?: any[]) { //adds .pos
        if (!overwrite) overwrite = new Array(ia.length);
        for (let i = 0; i < ia.length; i++) {
            overwrite[i] = { pos: { x: ia[i].x, y: ia[i].y } };
        }
        return overwrite;
    },
    xy_flat: function (ia: XY[], overwrite?: Float32Array): Float32Array { // [{x: 0.1, y: 0.2}, {x: 0.3, y: 0.5}] -> [0.1, 0.2, 0.3, 0.5]
        overwrite = overwrite || new Float32Array(ia.length * 2);
        for (let i = 0; i < ia.length; i++) {
            overwrite[i * 2] = ia[i].x;
            overwrite[i * 2 + 1] = ia[i].y;
        }
        return overwrite;
    },
    flat_xy: function (ia: any[], overwrite?: any[]): XY[] { // [{x: 0.1, y: 0.2}, {x: 0.3, y: 0.5}] -> [0.1, 0.2, 0.3, 0.5]
        if (!overwrite) overwrite = new Array(Math.ceil(ia.length * 0.5));
        for (let i = 0; i < overwrite.length; i++) {
            overwrite[i] = { x: ia[i * 2], y: ia[i * 2 + 1] };
        }
        return overwrite;
    },
    box_xy: function (box: BOX): XY[] {
        return [{ x: box.x, y: box.y }, { x: box.xx, y: box.y }, { x: box.xx, y: box.yy }, { x: box.x, y: box.yy }];
    },
    merge_xy: function (t: any) { // merges two long array: {x: [0.92383, 0.12338], y: [0.8837, 0.83837]} -> [0.92383, 0.8837, 0.12338, 0.83837] (float32)
        const output = new Float32Array(t.x.length * 2);
        for (let i = 0; i < t.x.length; i++) {
            const index = i * 2;
            output[index] = t.x[i];
            output[index + 1] = t.y[i];
        }
        return output;
    }
};